// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2SmxY","title":"Info_title__OkQ-j","selects":"Info_selects__2k-G_","requiredAsterisk":"Info_requiredAsterisk__27zLc"};